import { Spin } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './GalleryPreviewImage.css';

export interface GalleryPreviewImageProps {
    previewSource: string;
}

interface GalleryPreviewImageState {
    isLoaded: boolean;
    previewSource?: string;
}

const BLOCK = 'gallery-preview-image';

export class GalleryPreviewImage extends React.PureComponent<GalleryPreviewImageProps, GalleryPreviewImageState> {
    state: GalleryPreviewImageState = {
        isLoaded: false
    };

    static getDerivedStateFromProps(nextProps: GalleryPreviewImageProps, prevState: GalleryPreviewImageState) {
        const { previewSource } = nextProps;

        if (nextProps.previewSource === prevState.previewSource) {
            return {
                ...prevState
            };
        }

        // если пришел новый previewSource сбрасываем isLoaded и ждем пока изображение
        // отсигналит, что оно загрузилось
        return { isLoaded: false, previewSource };
    }

    render() {
        const { previewSource } = this.props;
        const { isLoaded } = this.state;

        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    mods: { loaded: this.state.isLoaded ? 'yes' : 'no' }
                })}
            >
                {' '}
                <img src={previewSource} className={Bem.cls(BLOCK, 'preview')} onLoad={this.handleImageLoaded} />
                {!isLoaded && <Spin cls={Bem.cls(BLOCK, 'spin')} size={'l'} progress={true} />}
            </div>
        );
    }

    private handleImageLoaded = () => {
        this.setState({ isLoaded: true });
    };
}
